import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Pokedex from "./pages/Pokedex";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import NotFound from "./pages/NotFound";
import Updates from "./pages/Updates";
import Pokemon from "./pages/Pokemon";
const root = ReactDOM.createRoot(document.getElementById("root"));

const to = {
  pathname: "/pokemon",
  search: "?class=A",
  hash: "#pokemon-hash",
  state: { test: "test-state" },
};

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/pokedex" element={<Pokedex />} />
      <Route path="/updates" element={<Updates />} />
      <Route path="/pokemon">
        <Route path=":pokemon" element={<Pokemon />} />
      </Route>
      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);
